<template>
  <section>
    <!--工具条-->
    <!-- <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar> -->
    <div>
      <el-col :span="3">
        <el-input
          v-model="filters.key"
          placeholder="编号/标题/工程/客户"
          @change="getProdTask(1)"
        ></el-input>
      </el-col>
      <el-col :span="3">
        <el-select
          v-model="filters.gradeName"
          filterable
          placeholder="请选择"
          @change="getProdTask(1)"
          :clearable="true"
        >
          <el-option
            v-for="item in baseData.GradeList"
            :key="item.Name"
            :label="item.Name"
            v-model="item.Name"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="3">
        <template>
          <el-select
            v-model="filters.orgCode"
            filterable
            placeholder="请选择"
            @change="getProdTask(1)"
          >
            <el-option
              v-for="item in orgList"
              :key="item.OrgCode + 'Seach'"
              :label="item.Name"
              v-model="item.OrgCode"
            ></el-option>
          </el-select>
        </template>
      </el-col>
      <el-col :span="9">
        <el-date-picker
          type="datetime"
          placeholder="计划时间"
          v-model="filters.startTime"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
        -
        <el-date-picker
          type="datetime"
          placeholder="计划时间"
          v-model="filters.endTime"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
      </el-col>
      <el-col :span="3">
        <el-button type="primary" @click="getProdTask(1)">查询</el-button>
      </el-col>
    </div>
    <!--列表-->
    <el-table
      :data="prodTask"
      highlight-current-row
      v-loading="listLoading"
      style="width: 100%"
      height="600"
      :border="true"
    >
      <el-table-column label="编号" width="180" fixed>
        <template slot-scope="scope">
          <el-link type="primary" @click="handleDetail(scope.row)">
            {{ scope.row.Code }}
          </el-link>
        </template>
      </el-table-column>
      <el-table-column label="工程客户信息" width="250">
        <template slot-scope="scope" style="max-height: 100%">
          <div>{{ scope.row.ProjectName }}</div>
          <div>{{ scope.row.ClientName }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="PlanDate"
        label="计划时间"
        width="140"
        :formatter="formatTime"
      ></el-table-column>
      <el-table-column
        prop="PlanQuantity"
        label="计划方量"
        width="80"
      ></el-table-column>
      <el-table-column label="强度等级" width="80">
        <template slot-scope="scope">
          <div>{{ scope.row.GradeName }} {{ scope.row.SpecMtlName }}</div>
          <div></div>
        </template>
      </el-table-column>

      <el-table-column
        prop="ProjectPart"
        label="施工部位"
        width="180"
      ></el-table-column>
      <el-table-column prop="WorkMethodName" label="浇筑方式"></el-table-column>
      <el-table-column prop="IsPumping" label="泵送" width="">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.IsPumping == 1 ? 'success' : 'info'"
            disable-transitions
          >
            {{ scope.row.IsPumping == 1 ? "是" : "否" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="ConstructionAddress"
        label="送货地址"
      ></el-table-column>
      <el-table-column prop="OrgName" label="所在机构"></el-table-column>
      <el-table-column prop="Title" label="任务标题"></el-table-column>

      <el-table-column prop="QuantityTotal" label="累计方量"></el-table-column>
      <el-table-column prop="Remark" label="备注"></el-table-column>

      <el-table-column prop="Status" label="状态" width="">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.Status == 0 ? 'success' : 'info'"
            disable-transitions
          >
            {{ scope.row.Status == 0 ? "正常" : "归档" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="RecipeCodes" label="配方名称" width="800px">
        <template prop="RecipeCodes" slot-scope="scope">
          <span
            v-for="item in getRecipeCodesInString(scope.row.RecipeCodes)"
            :key="item.StationLineID"
          >
            <el-link
              type="primary"
              @click="handleDetailById(item)"
              style="margin: 0 5px"
            >
              {{ item.StationLineName }}({{ item.RecipeTitle }})
            </el-link>
          </span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150" fixed="right">
        <template slot-scope="scope">
          <el-link
            type="primary"
            v-if="canApproval"
            @click="
              () => {
                handleWorkflow(scope.row);
              }
            "
          >
            审批
          </el-link>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      layout="total, sizes, prev, pager, next, jumper"
      :page-size="filters.pageSize"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
      class="my-pagination"
    ></el-pagination>
    <!-- 详情 -->
    <el-dialog
      title="详情"
      :visible.sync="isShowDetail"
      v-model="isShowDetail"
      :close-on-click-modal="false"
      append-to-body
    >
      <table class="table-bordered" style="">
        <tr>
          <th>任务标题</th>
          <td>{{ DetailDm.Title }}</td>
          <th>工程名称</th>
          <td>{{ DetailDm.ProjectName }}</td>
        </tr>
        <tr>
          <th>客户名称</th>
          <td>{{ DetailDm.ClientName }}</td>
          <th>运输距离</th>
          <td>{{ DetailDm.Distance }}</td>
        </tr>
        <tr>
          <th>计划方量</th>
          <td>{{ DetailDm.PlanQuantity }}</td>
          <th>计划时间</th>
          <td>{{ DetailDm.PlanDate }}</td>
        </tr>
        <tr>
          <th>塌落度</th>
          <td>{{ DetailDm.TLD }}</td>
          <th>强度等级</th>
          <td>{{ DetailDm.GradeName }} / {{ DetailDm.SpecMtlName }}</td>
        </tr>
        <tr>
          <th>是否泵送</th>
          <td>{{ DetailDm.IsPumping == 1 ? "是" : "否" }}</td>
          <th>浇筑方式</th>
          <td>{{ DetailDm.WorkMethodName }}</td>
        </tr>
        <tr>
          <th>施工地址</th>
          <td>{{ DetailDm.ConstructionAddress }}</td>
          <th>施工部位</th>
          <td>{{ DetailDm.ProjectPart }}</td>
        </tr>
        <tr>
          <th>联系人</th>
          <td>{{ DetailDm.ContactName }}</td>
          <th>联系电话</th>
          <td>{{ DetailDm.ContactPhone }}</td>
        </tr>
        <tr>
          <th>备注</th>
          <td colspan="3">{{ DetailDm.Remark }}</td>
        </tr>
      </table>
    </el-dialog>

    <!-- 审批详情 -->
    <el-dialog
      title="审批流"
      :visible.sync="isShowWorkflow"
      v-model="isShowWorkflow"
      :close-on-click-modal="false"
      append-to-body
    >
      <!--列表-->
      <el-table
        :data="workflowHistryList"
        highlight-current-row
        style="width: 100%"
        :border="true"
      >
        <el-table-column prop="CreateUser" label="审批人"></el-table-column>
        <el-table-column prop="ApprovalContent" label="批注"></el-table-column>
        <el-table-column prop="OpType" label="审批状态" width="">
          <template slot-scope="scope">
            {{
              scope.row.OpType == 100
                ? "提交"
                : scope.row.OpType == 200
                ? "通过"
                : "驳回"
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="CreateTime"
          label="审批时间"
          :formatter="formatDate"
          sortable
        ></el-table-column>
      </el-table>
      <el-form
        v-if="showApprovalRecord"
        :model="approvalRecord"
        label-width="120px"
      >
        <el-form-item label="审批批注" prop="OpType">
          <template>
            <el-radio-group v-model="approvalRecord.OpType">
              <el-radio :label="200">通过</el-radio>
              <el-radio :label="300">驳回</el-radio>
            </el-radio-group>
          </template>
        </el-form-item>
        <el-form-item label="批注" prop="ApprovalContent">
          <el-input
            type="textarea"
            v-model="approvalRecord.ApprovalContent"
            auto-complete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div v-if="showApprovalRecord" slot="footer" class="dialog-footer">
        <el-button @click.native="isShowWorkflow = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="addWfSubmit"
          :loading="addLoading"
        >
          提交
        </el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
//引入ProdTask.js的所有export的对象,并起别名为api,通过api.***访问成员
import * as api from "../../api/prodTask";
import * as wfapi from "../../api/approvalRecord";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import TableDataDialog from "../../components/TableDataDialog";
import util from "../../../util/date";
export default {
  components: { Toolbar, TableDataDialog },
  data() {
    return {
      buttonList: [],
      filters: {
        orgCode: "",
        pageSize: 1,
        page: 1,
        startTime: "",
        endTime: "",
      },
      prodTask: [],
      baseData: [], //任务单基础数据
      orgList: JSON.parse(localStorage.sysOrgs),
      total: 0,
      listLoading: false,
      sels: [], //列表选中列
      addLoading: false,
      isShowDetail: false,
      DetailDm: {},
      approvalCompetencesList: [], //审批信息
      currentuser: { uID: 0 }, //当前用户信息
      workflowHistryList: [], //工作流历史信息
      isShowWorkflow: false, //是否显示工作流详情
      approvalRecord: { OpType: 200 }, //审批信息
      showApprovalRecord: true, //是否显示审批信息
    };
  },
  computed: {
    canApproval() {
      return this.approvalCompetencesList.length > 0;
    },
  },
  methods: {
    //格式化RecipeCodes
    getRecipeCodesInString(str) {
      if (str && str != "-1") {
        return JSON.parse(str);
      }
      return {};
    },
    //翻页事件绑定方法
    handleCurrentChange(val) {
      this.filters.page = val;
      this.getProdTask();
    },
    //获取任务
    getProdTask(optype) {
      if (optype == 1) {
        this.filters.page = 1;
      }
      let para = this.filters;
      if (this.approvalCompetencesList.length > 0) {
        para.maxOpNode = Math.max.apply(
          Math,
          this.approvalCompetencesList.map((item) => {
            return item.OpNode;
          })
        );
        para.minOpNode =
          Math.min.apply(
            Math,
            this.approvalCompetencesList.map((item) => {
              return item.OpNode;
            })
          ) - 1;
      }
      this.listLoading = true;
      api.getProdTaskListPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.prodTask = res.data.response.data;
        this.listLoading = false;
        this.sels = [];
      });
    },
    getBaseData() {
      api.getGetProdTaskBaseData().then((res) => {
        this.baseData = res.data.response;
      });
    },
    //提交任务单打开
    handleWorkflow(row) {
      this.showApprovalRecord = true;
      this.isShowWorkflow = true;
      let para = { opId: row.Id, dataType: 100 };
      this.approvalRecord.DataType = 100;
      this.approvalRecord.DataID = row.Id;
      this.approvalRecord.OpType = 200; //200位通过
      wfapi.getApprovalRecordList(para).then((res) => {
        this.workflowHistryList = res.data.response;
      });
      //需要一个弹出框，显示任务信息，显示后续审批人信息,一个请求获取审核记录，一个当前审核备注
      //一个提交按钮，一个取消按钮
      //点击提交按钮后，当前数据状态变成我的审批权限中的最大值
    },
    addWfSubmit() {
      this.addLoading = true;
      //300为驳回，驳回时节点变为0
      if (this.approvalRecord.OpType == 300) {
        this.approvalRecord.OpNode = 0;
      } else {
        this.approvalRecord.OpNode = Math.max.apply(
          Math,
          this.approvalCompetencesList.map((item) => {
            return item.OpNode;
          })
        );
      }

      let para = Object.assign({}, this.approvalRecord);

      let user = JSON.parse(window.localStorage.user);

      if (user && user.uID > 0) {
      } else {
        this.$message({
          message: "登录信息已过期,请重新登录",
          type: "error",
        });
        this.$router.replace(
          this.$route.query.redirect ? this.$route.query.redirect : "/"
        );
      }

      wfapi
        .addApprovalRecord(para)
        .then((res) => {
          if (res && res.data && res.data.success) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.isShowWorkflow = false;
            this.getProdTask();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        })
        .finally(() => {
          this.addLoading = false;
        });
    },
    // 显示窗口
    handleDetail(row) {
      this.DetailDm = row;
      this.isShowDetail = !this.isShowDetail;
    },
    //切换分页大小绑定方法
    handleSizeChange(size) {
      this.filters.pageSize = size;
      this.getProdTask();
    },

    formatTime(row, column) {
      return !row.PlanDate || row.PlanDate == ""
        ? ""
        : util.formatDate.format(new Date(row.PlanDate), "yyyy-MM-dd hh:mm");
    },
  },
  mounted() {
    /*获取任务单基础档案*/
    if (localStorage.currentOrg) {
      this.filters.orgCode = JSON.parse(localStorage.currentOrg).OrgCode;
    } else if (localStorage.sysOrgs) {
      this.filters.orgCode = JSON.parse(localStorage.sysOrgs)[0].OrgCode;
    }
    if (window.localStorage.user) {
      this.currentuser = JSON.parse(window.localStorage.user);
    }
    /*获取审批权限*/
    if (localStorage.ApprovalCompetences) {
      var listAC = JSON.parse(localStorage.ApprovalCompetences).filter(
        (k) => k.DataType == 100 && k.DataUserID == this.currentuser.uID
      );
      if (listAC && listAC.length > 0) {
        this.approvalCompetencesList = listAC;
      }
    }

    /*获取任务单基础档案*/
    this.getProdTask();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    this.getBaseData();
  }, //格式化时间
};
</script>

<style lang="less" scoped>
.input-select {
  width: 300px;
}
.date-style /deep/ .el-input__inner {
  width: 230px !important;
}
</style>
